import { ContextBar } from '@sailadv/hdata-ui';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { selectBoat } from '@/entities/boat';
import { NotificationMenu } from '@/entities/notifications';
import { useIsB2COwner } from '@/entities/user';
import { DomainSwitcher } from '@/features/domain-switcher';
import { ScopeSwitcher } from '@/features/pick-boat';
import { ProductSwitcher } from '@/features/product-switcher';

import { UserMenu } from '../user-menu';

const HeaderComponent = () => {
	const isB2COwner = useIsB2COwner();
	const boatsCount = useSelector(selectBoat.selectTotal);
	const isSingleBoatOwner = isB2COwner && boatsCount === 1;

	return (
		<header className="flex items-center gap-2 pr-3">
			<ContextBar className="flex-1 overflow-x-auto border-b-0! bg-transparent!">
				<DomainSwitcher />
				{isSingleBoatOwner
					? [<ScopeSwitcher key="scope" />, <ProductSwitcher key="product" />]
					: [<ProductSwitcher key="product" />, <ScopeSwitcher key="scope" />]}
			</ContextBar>
			<div className="flex items-center gap-1.5">
				<NotificationMenu />
				<UserMenu />
			</div>
		</header>
	);
};

export default memo(HeaderComponent);
